import React, { ReactNode, useCallback, useState } from 'react'

import useFetch from 'src/hooks/useFetch'

const getApiUrl = () => process.env.API_URL

export interface WizardCtx {
  dashboard: ReadonlyArray<any>
  detailsData: object
  getDashboard: () => Promise<any>
  getDetailsData: () => Promise<any>
}

export const WizardContext = React.createContext<WizardCtx>({} as WizardCtx)

const WizardProvider = ({ children }: { children: ReactNode }) => {
  const [dashboard, setDashboard] = useState<ReadonlyArray<any>>([])
  const [detailsData, setDetailsData] = useState<object>({ details_status: [] })
  const [isLoading, setIsLoading] = useState(false)

  const [, executeGetDashboard] = useFetch<any>(
    {
      url: `${getApiUrl()}/api/data_status_wizard`,
      method: 'GET',
    },
    { manual: true },
  )

  const [, executeGetDetailsData] = useFetch<any>(
    {
      url: `${getApiUrl()}/api/last_seven_data_status_wizard`,
      method: 'GET',
    },
    { manual: true },
  )

  const getDashboard = useCallback(async () => {
    setIsLoading(true)
    const { data: dashboard } = await executeGetDashboard(undefined, undefined).finally(() =>
      setIsLoading(false),
    )
    setDashboard(dashboard)
  }, [executeGetDashboard])

  const getDetailsData = useCallback(async () => {
    const { data: detailsData } = await executeGetDetailsData()
    setDetailsData(detailsData)
  }, [executeGetDetailsData])

  const contextValue = {
    dashboard,
    detailsData,
    getDashboard,
    getDetailsData,
    isLoading,
  }

  return <WizardContext.Provider value={contextValue}>{children}</WizardContext.Provider>
}

export default WizardProvider
